var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocapprove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 262.304,
    height: 44.514,
    viewBox: "0 0 262.304 44.514",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "docapprove",
    transform: "translate(-1447.548 -2154.009)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4",
    "data-name": "Groupe 4",
    transform: "translate(1407.87 2154.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3",
    "data-name": "Groupe 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Approve",
    d: "M28.05,0l-.033-23.1H25.311l-9.5,16.236L6.171-23.1H3.465V0H6.633V-16.731L14.982-2.805H16.5L24.849-16.83,24.882,0Zm22.6-4.158a9.776,9.776,0,0,1-5.412,1.485c-5.313,0-9.174-3.8-9.174-8.877,0-5.148,3.861-8.877,9.207-8.877a9.158,9.158,0,0,1,6.7,2.673L54.021-19.8a11.579,11.579,0,0,0-8.877-3.564c-7.161,0-12.375,4.983-12.375,11.814S37.983.264,45.078.264a13.652,13.652,0,0,0,8.745-2.937v-9.009H50.655ZM59.8,0h3.3V-23.1H59.8ZM95.5,0h3.465L88.473-23.1H85.206L74.745,0h3.4l2.541-5.775H92.961ZM81.84-8.415l4.983-11.319L91.806-8.415Zm29.04-9.24a7.449,7.449,0,0,0-6.237,2.937V-17.49h-3.036V6.4h3.168V-2.64A7.469,7.469,0,0,0,110.88.2a8.5,8.5,0,0,0,8.844-8.943A8.489,8.489,0,0,0,110.88-17.655Zm-.264,15.081c-3.333,0-5.874-2.442-5.874-6.171a5.775,5.775,0,0,1,5.874-6.138,5.782,5.782,0,0,1,5.907,6.138A5.791,5.791,0,0,1,110.616-2.574Zm22.44-15.081a7.449,7.449,0,0,0-6.237,2.937V-17.49h-3.036V6.4h3.168V-2.64A7.469,7.469,0,0,0,133.056.2,8.5,8.5,0,0,0,141.9-8.745,8.489,8.489,0,0,0,133.056-17.655Zm-.264,15.081c-3.333,0-5.874-2.442-5.874-6.171a5.775,5.775,0,0,1,5.874-6.138A5.782,5.782,0,0,1,138.7-8.745,5.791,5.791,0,0,1,132.792-2.574ZM149-14.553V-17.49h-3.036V0h3.168V-8.712c0-3.828,2.112-5.907,5.511-5.907a5.594,5.594,0,0,1,.726.033v-3.069C152.3-17.655,150.117-16.6,149-14.553ZM166.254.2a8.7,8.7,0,0,0,9.075-8.943,8.676,8.676,0,0,0-9.075-8.91c-5.247,0-9.108,3.7-9.108,8.91A8.729,8.729,0,0,0,166.254.2Zm0-2.772a5.791,5.791,0,0,1-5.907-6.171,5.764,5.764,0,0,1,5.907-6.138c3.366,0,5.874,2.409,5.874,6.138S169.62-2.574,166.254-2.574ZM191.268-17.49,185.13-3.465,179.124-17.49h-3.3L183.48,0h3.234l7.656-17.49Zm21.054,8.844c0-5.379-3.6-9.009-8.646-9.009a8.566,8.566,0,0,0-8.778,8.91C194.9-3.531,198.66.2,204.3.2a8.779,8.779,0,0,0,6.9-2.838l-1.749-2.046A6.53,6.53,0,0,1,204.4-2.574c-3.465,0-5.94-2.046-6.336-5.115h14.19C212.289-7.986,212.322-8.382,212.322-8.646Zm-8.646-6.336a5.454,5.454,0,0,1,5.61,5.016h-11.22A5.452,5.452,0,0,1,203.676-14.982Z",
    transform: "translate(89.66 33)",
    fill: "#fff",
    opacity: 0.796
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_797",
    "data-name": "Groupe 797",
    transform: "translate(1447.548 2154.157)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo-Approve",
    transform: "translate(0 -0.148)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1425",
    "data-name": "Rectangle 1425",
    d: "M0,110.535H42.982v13.683a3.741,3.741,0,0,1-3.742,3.742H3.741A3.741,3.741,0,0,1,0,124.218Z",
    transform: "translate(0 -84.978)",
    fill: "#064b93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1426",
    "data-name": "Rectangle 1426",
    d: "M42.982,25.409H0V4.158A4.306,4.306,0,0,1,4.306-.148h34.37a4.306,4.306,0,0,1,4.306,4.306V25.409Z",
    transform: "translate(0 0.148)",
    fill: "#1794cd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1452",
    "data-name": "Trac\\xE9 1452",
    d: "M47.842,24.827a14.247,14.247,0,0,1,7.1,3.3c-.606.552-1.194,1.127-1.762,1.707a11.855,11.855,0,1,0,4.057,6.8,20.815,20.815,0,0,1,2.2-1.318A14.315,14.315,0,1,1,47.84,24.829",
    transform: "translate(-24.054 -18.924)",
    fill: "#004b93",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1453",
    "data-name": "Trac\\xE9 1453",
    d: "M57.979,40.364a14.266,14.266,0,0,1,5.7-2.443,18.5,18.5,0,0,1,2.647,6.888c4.578-5.916,10.293-13.248,15.684-14.331a24.1,24.1,0,0,0-1.572,7.777c-5.788,1.7-11.305,8.3-15.111,12.7-1.345-3.568-3.8-8.844-7.349-10.595",
    transform: "translate(-44.591 -23.406)",
    fill: "#fff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "AP",
    transform: "translate(11.487 25.68)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "AP-2",
    "data-name": "AP",
    transform: "translate(-0.487 13.687)",
    fill: "#fff",
    fontSize: 16,
    fontFamily: "Young",
    letterSpacing: "0.03em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "AP")), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_796",
    "data-name": "Groupe 796",
    transform: "translate(0.095 3.099)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1463",
    "data-name": "Trac\\xE9 1463",
    d: "M56.891,126.082h1.546l4.743,11.287H61.443l-1.347-3.2H55.234l-1.332,3.2H52.148Zm1.443.156h-1.34l-4.612,10.975H53.8l1.332-3.2H60.2l1.347,3.2h1.4Zm-.662,1.773,1.972,4.7H55.684Zm1.738,4.543-1.739-4.143-1.753,4.143Z",
    transform: "translate(-52.603 -126.762)",
    fill: "#feffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1464",
    "data-name": "Trac\\xE9 1464",
    d: "M107.016,126.143a3.8,3.8,0,0,1,1.506.309,3.914,3.914,0,0,1,1.25.845,4.059,4.059,0,0,1,.847,1.258,3.783,3.783,0,0,1,.315,1.536,3.821,3.821,0,0,1-.315,1.552,4.054,4.054,0,0,1-.847,1.258,3.911,3.911,0,0,1-1.251.845,3.8,3.8,0,0,1-1.505.309h-2.821v3.376h-1.642V126.143Zm0,7.755a3.652,3.652,0,0,0,1.445-.3,3.756,3.756,0,0,0,1.2-.811,3.9,3.9,0,0,0,.814-1.21,3.667,3.667,0,0,0,.3-1.489,3.63,3.63,0,0,0-.3-1.474,3.9,3.9,0,0,0-.814-1.21,3.759,3.759,0,0,0-1.2-.811,3.652,3.652,0,0,0-1.445-.3h-4.308v10.975h1.332V133.9Zm0-6.29a2.281,2.281,0,0,1,.932.2,2.545,2.545,0,0,1,.775.534,2.425,2.425,0,0,1,.523.789,2.477,2.477,0,0,1,.187.962,2.513,2.513,0,0,1-.187.977,2.419,2.419,0,0,1-.523.79,2.542,2.542,0,0,1-.775.534,2.285,2.285,0,0,1-.949.2H104.04v-4.981Zm0,4.825a2.129,2.129,0,0,0,.869-.184,2.386,2.386,0,0,0,.728-.5,2.262,2.262,0,0,0,.489-.739,2.358,2.358,0,0,0,.175-.917,2.323,2.323,0,0,0-.175-.9,2.27,2.27,0,0,0-.489-.739,2.391,2.391,0,0,0-.728-.5,2.128,2.128,0,0,0-.87-.185h-2.818v4.669Z",
    transform: "translate(-89.865 -126.822)",
    fill: "#feffff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocapprove);
export default __webpack_public_path__ + "static/media/docapprove.1c53d7f91877eac1f7050fe3e23ba5c4.svg";
export { ForwardRef as ReactComponent };